import { useMemo } from 'react'
import { REACT_APP_PROVIDERS_BASE_URL, REACT_APP_TCP } from '../../config/settings/environment'

/**
 * Custom hook to get url dinamic.
 */
export const useProviderFileUrl = orgTaxID => {
  return useMemo(() => {
    return `${REACT_APP_PROVIDERS_BASE_URL}/ficha/habilidad/${orgTaxID}`
  }, [])
}
export const useMyPymeFileUrl = accessToken => {
  return useMemo(() => {
    return `${REACT_APP_PROVIDERS_BASE_URL}/mi-empresa/historial-pagos?t=${accessToken}`
  }, [])
}
export const useTribunalTcpUrl = quoteId => {
  return useMemo(() => {
    return `${REACT_APP_TCP}/search?proc=3&tipoMecanismo=CA&codigoMecanismo=${quoteId}`
  }, [])
}
